<template>
  <div class="animated fadeIn">

    <b-row>
      <b-col lg="12">
        <c-table :toppagination="true" v-on:update-orders="refreshData" :fixed="true" :isBusy="loading" :table-data="items" :fields="fields" :cartitemFields="cartitemFields" caption="<i class='fa fa-align-justify'></i> Orders"></c-table>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import cTable from './utils/ordersTable'

export default {
  name: 'tables',
  components: {cTable},
  mounted(){
    this.refreshData();
  },
  data(){
    let permissions = this.$store.getters.canAccess({configkey:'permissions'});
    return {
      permissions,
      loading:false,
      items: [],
      fields: [
        {key: 'id', label: 'Order Id', sortable:true},
        {key: 'manualQuoteOrder', label: 'Order Type',sortable:true},
        {key: 'total',label: 'Total Amount'},
        {key: 'status', label: 'Status'},
        {key: 'createdAt', label: 'Created Date'},
        {key: 'updatedAt', label: 'Updated Date'},
      ],
      cartitemFields:[
        {key: 'id', label: 'Id'},
        {key: 'fileId',label: 'File Id'},
        (this.$store.getters.isAdmin ? {key: 'mfvendor',label: 'Vendor',sortable:true} : {}),
        {key: 'isManualQuote', label: 'Type'},
        {key: 'origName', label: 'File Name'},
        {key: 'process', label: 'Process'},
        {key: 'material', label: 'Material'},
        {key: 'quality', label: 'Quality'},
        {key: 'color', label: 'Color'},
        {key: 'quantity', label: 'Quantity'},
        {key: 'price', label: 'SubTotal'},
        {key: 'actions', label: 'Action'},
      ]
    }
  },
  methods:{
    async refreshData(){
      let filter = this.$route.path==='/orders/completed' ?  'status_in=Completed&status_in=Delivered&status_in=Canceled' : 'status_nin=Completed&&status_nin=Delivered&status_nin=Canceled';
      let orders= await this.strapi.axios.get('/orders?_sort=id:DESC&'+filter);
      this.items=(orders && orders.status=='200' && orders.data) || [];
    }
  },
  watch:{
    $route (to,from){
      this.refreshData();
    }
  }
}
</script>

<style scoped>

</style>